import { Button, Input, Modal, Select } from "antd";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import FormWrapper from "../../../components/FormWrapper/FormWrapper";
import { Note } from "../../../components/Note";
import { API } from "../../../core/api";
import {
  checkValidEngNumbers,
  getCities,
  onChangeProvince,
} from "../../../core/utils";
import CloseModalButton from "../../../components/CloseModalButton/CloseModalButton";

const { Option } = Select;
const EditDriver = ({ isModalOpen, setIsModalOpen, onFilterDrivers, data }) => {
  const provinces = useSelector((state) => state.Store.provinces);
  const [cities, setCities] = useState([]);
  const [state, setState] = useState({
    province: provinces.find((province) => province.name === data.province)?.id,
    city_id: data.city,
    first_name: data.user?.first_name,
    last_name: data.user?.last_name,
    national_id: data.user.national_id,
  });

  const handleChange = (data) => {
    setState({
      ...state,
      ...data,
    });
  };

  const getCitiesList = () => {
    getCities(state.province).then((response) => {
      if (response.success) {
        setCities(response.data);
      } else {
        Note.error(response.message);
      }
    });
  };

  useEffect(() => {
    if (isModalOpen && !cities.length) {
      getCitiesList();
    } else if (cities.length && state.city_id) {
      handleChange({
        city_id: cities.find((city) => city.name === data.city)?.id,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cities.length, isModalOpen]);

  const onEditDriver = (company_driver_id) => {
    const newState = { ...state, company_driver_id };
    if (!newState.city_id) {
      return Note.error("شهر الزامی است");
    }
    if (!newState.first_name) {
      return Note.error("نام الزامی است");
    }
    if (!newState.last_name) {
      return Note.error("نام خانوادگی الزامی است");
    }
    if (!newState.national_id) {
      return Note.error("کد ملی الزامی است");
    }
    delete newState.province;

    // API.put.put_driver(newState).then((response) => {
    //   if (response.success) {
    //     Note.success(response.message);
    //     setIsModalOpen(false);
    //     onFilterDrivers();
    //   } else {
    //     Note.error(response.message);
    //   }
    // });
  };

  return (
    <Modal
      open={isModalOpen}
      onCancel={() => setIsModalOpen(false)}
      footer={null}
      closable={true}
      title="ویرایش راننده"
      bodyStyle={{
        paddingBottom: 8,
      }}
      closeIcon={
        <CloseModalButton isCloseIcon close={() => setIsModalOpen(false)} />
      }
    >
      <div className="flex-row flex-wrap flex-content-space-between">
        <FormWrapper>
          <Select
            className="border-black-8 my-5 "
            showSearch
            onChange={(value) =>
              onChangeProvince(
                value,
                () => handleChange({ province: value, city_id: null }),
                setCities
              )
            }
            placeholder={"استان"}
            value={state.province}
          >
            <Option value={null} name="همه استان ها">
              همه استان ها
            </Option>
            {provinces.map((province) => {
              return (
                <Option value={province.id} key={province.id}>
                  {province.name}
                </Option>
              );
            })}
          </Select>
          <Select
            className="border-black-8 my-5  "
            showSearch
            onChange={(value) => handleChange({ city_id: value })}
            placeholder={"شهر"}
            value={state.city_id}
          >
            <Option value={null} name="همه شهر ها">
              همه شهر ها
            </Option>
            {cities.map((city) => {
              return (
                <Option key={city.name} value={city.id}>
                  {city.name}
                </Option>
              );
            })}
          </Select>
          <Input
            className="input-black border-black-8 my-5 "
            placeholder="نام"
            onChange={(e) => handleChange({ first_name: e.target.value })}
            value={state.first_name}
          />
          <Input
            className="input-black border-black-8 my-5 "
            placeholder="نام خانوادگی"
            onChange={(e) => handleChange({ last_name: e.target.value })}
            value={state.last_name}
          />
          <Input
            className="input-black border-black-8 my-5  "
            placeholder="کد ملی"
            onChange={(e) => handleChange({ national_id: e.target.value })}
            value={state.national_id}
            onKeyDown={checkValidEngNumbers}
          />

          <Button
            className="button-secondary  my-5 "
            onClick={() => onEditDriver(data.pk)}
          >
            ویرایش
          </Button>
        </FormWrapper>
      </div>
    </Modal>
  );
};

export default EditDriver;
